// src/pages/ChapterNine.js
// Chapter 9 — Crocodile Delta: Final Star Trial
// Story: This is the LAST Treblin milestone. The crocodiles set a final music test.
// Pass it to earn the FINAL STAR that completes the Star Quest puzzle.
// After completion, Giz the Star Gazer deciphers the ANCIENT MELODY from the constellation,
// revealing the secret weapon you’ll use against Doron in Chapter 10.

import React from "react";
import ChapterTemplate from "../components/ChapterTemplate";

// 🎵 Final Trial Melody: "Row, Row, Row Your Boat" (PUBLIC DOMAIN)
// Your provided notes (kept as-is). We use "__" spacers only for visual grouping.
// Range stays within G3 → E5 (fits VirtualPiano + RealPianoListener).
//
// Phrases (from your message):
// 1) E E E   E F# G#
// 2) G# F# G# A B
// 3) E5 E5 E5   B4 B4 B4   G# G# G#   E E E
// 4) B4 A G# F# E
const crocLines = [
  // 1
  ["E", "E", "__", "E", "F#", "G#"],
  // 2
  ["G#", "F#", "G#", "A", "B"],
  // 3
  ["E5", "E5", "E5", "__", "B4", "B4", "B4", "__", "G#", "G#", "G#", "__", "E", "E", "E"],
  // 4
  ["B4", "A", "G#", "F#", "E"],
];

// Flatten for matching (template also flattens; this keeps it explicit here)
const crocMelody = crocLines.flat().filter((t) => t && t !== "__");

// 🖼️ Slides — crocodile exam → boat song trial → final star → Giz deciphers ancient melody
const ChapterNineStory = [
  {
    image: "/images/ChapterNine/Ch9 Slide 1.png",
    text:
      "Pan and Wis reach Crocodile Delta. The water is still, and watchful eyes rise above the surface.",
  },
  {
    image: "/images/ChapterNine/Ch9 Slide 2.png",
    text:
      "“Doron has been attacking us as well, no one is safe from his hunger, even though dragons are crocodiles with wings!.”",
  },
  {
    image: "/images/ChapterNine/Ch9 Slide 3.png",
    text:
      "This is Treblin’s final milestone. Play the boat song to earn the final star and complete the Star Quest puzzle.",
  },
  {
    image: "/images/ChapterNine/Ch9 Slide 4.png",
    text:
      "We crocodiles are the anicent cousins of Dragons, after this song you should be ready to battle Doron!",
    melody: true, // shows the melody panel if no explicit scene image is set
  },


];

export default function ChapterNine() {
  return (
    <ChapterTemplate
      chapterNumber={9}
      chapterTitle="Crocodile Delta — Final Star Trial"
      sceneImageSrc="/images/ChapterNine/Ch9 Melody.png"
      storySlides={ChapterNineStory}
      targetMelody={crocMelody}
      melodyLines={crocLines}
      songTitle='Row, Row, Row Your Boat (Final Star Trial)'
      companionsText={{
        wis:
          "Stay calm and count your steps. Repeats and tiny moves—keep everything clean and even.",
        pan:
          "Perfect this boat song and we’ll earn the FINAL STAR! Then Giz can unlock the ancient melody from the constellation map.",
      }}
      // Doron remains asleep in Chapter 9; he awakens for the final battle in Chapter 10.
      unlockNextChapterPath="/chapter-10"
    />
  );
}
